<nz-table
  #limTable
  [nzShowPagination]="false"
  [nzData]="gridValues"
  [nzScroll]="{ x: '100%', y: '204px' }"
  nzBordered="true"
  [nzLoadingIndicator]="loadSkeleton"
  class="line-item-monitor-grid"
  [nzLoading]="isLoading"
  [nzWidthConfig]="widthConfig"
>
  <thead>
    <tr>
      <ng-container
        *ngFor="let data of gridHeader.level1; index as periodIndex"
      >
        <th
          *ngIf="periodIndex === 0"
          [attr.rowspan]="data.rowspan"
          [attr.colspan]="data.colspan"
          nzLeft="0px"
          nzAlign="left"
        >
          <div class="header-div">
            <div>{{ data.label || "&nbsp;" }}</div>
          </div>
          <div *ngIf="periodIndex === 0" class="sub-header">
            {{ data.subscript }}
          </div>
        </th>
        <th
          *ngIf="periodIndex !== 0"
          [attr.rowspan]="data.rowspan"
          [attr.colspan]="data.colspan"
          nzAlign="right"
          class="period-header"
          nz-popover
          [(nzPopoverVisible)]="showPopovers[periodIndex - 1]"
          [nzPopoverContent]="periodTemplate"
          [nzPopoverOverlayClassName]="'period-popover'"
          nzPopoverPlacement="bottomRight"
          nzPopoverTrigger="click"
        >
          <div class="period-ctn">
            <div class="header-div period-selector">
              {{ data.label || "&nbsp;" }}
              <span class="icon">
                <va-icon
                  *ngIf="!showPopovers[periodIndex - 1]"
                  size="small"
                  name="chevron-down"
                  class="chevron-down"
                ></va-icon>
                <va-icon
                  *ngIf="showPopovers[periodIndex - 1]"
                  size="small"
                  name="chevron-up"
                  class="chevron-up"
                ></va-icon>
                <ng-template #periodTemplate class="edit-period-box">
                  <app-line-item-period-edit
                    (onItemChange)="
                      onPeriodChange(periodIndex - 1, $event[0], $event[1])
                    "
                    [ticker]="ticker"
                    [lineItemsMeta]="lineItemsMeta"
                    [periodIndex]="periodIndex"
                  ></app-line-item-period-edit>
                </ng-template>
              </span>
            </div>
            <nz-divider class="line" *ngIf="periodIndex !== 0"></nz-divider>
          </div>
        </th>
      </ng-container>
    </tr>
    <tr>
      <ng-container *ngFor="let periodData of gridHeader.level2">
        <th
          *ngFor="let data of periodData; last as isLast; first as isFirst"
          nzAlign="right"
          [ngClass]="{
            'first-cell': isFirst,
            'last-cell': isLast
          }"
        >
          {{ data.label }}
        </th>
      </ng-container>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of gridValues">
      <ng-container *ngIf="data">
        <td
          nzLeft="0px"
          nzAlign="left"
          nzBreakWord="false"
          class="row-header"
          nz-tooltip
          [nzTooltipTitle]="data.header"
        >
          <div
            (mouseover)="selectLineItem(data)"
            nz-popover
            nzPopoverTrigger="click"
            [nzPopoverContent]="linkPopoverTemplate"
            nzPopoverPlacement="right"
            nzPopoverOverlayClassName="lim-links-popover"
          >
            {{ data.header | textEllipsis: 32 }}
          </div>
        </td>
        <!-- chart column should be fixed at -- width of first column -->
        <td [nzLeft]="widthConfig[0]" class="chart-col">
          <va-icon
            name="chart-bar"
            class="chart-icon"
            (click)="showChartPopup(data, chartType)"
          ></va-icon>
        </td>

        <ng-container *ngIf="data.values; else emptyTd">
          <ng-container *ngFor="let periodValues of data.values">
            <ng-container *ngIf="periodValues; else emptyTd">
              <ng-container
                *ngFor="
                  let cell of periodValues;
                  index as periodIndex;
                  last as isLast
                "
              >
                <td
                  [ngClass]="{
                    'first-cell': periodIndex === 0,
                    'last-cell': isLast
                  }"
                  nzAlign="right"
                >
                  <div
                    *ngIf="cell.tooltip"
                    nz-tooltip
                    [nzTooltipTitle]="cell.tooltip"
                    [class]="!!cell.color ? cell.color : ''"
                  >
                    {{ cell.value }}
                  </div>
                  <span
                    *ngIf="!cell.tooltip"
                    [class]="!!cell.color ? cell.color : ''"
                  >
                    {{ cell.value }}
                  </span>
                </td>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </tr>
  </tbody>
</nz-table>

<!-- Lays out empty td's to occupy space in grid, otherwise grid with missing cells looks broken.
It uses first column from level2 header (gridHeader.level2[0]) to determine whether it has two columns or three columns per period -->
<ng-template #emptyTd>
  <td
    *ngFor="let data of gridHeader.level2[0]; last as isLast; first as isFirst"
    [ngClass]="{
      'first-cell': isFirst,
      'last-cell': isLast
    }"
  >
    &nbsp;
  </td>
</ng-template>

<ng-template #loadSkeleton>
  <ul nz-menu style="border: none">
    <li
      *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6, 7]"
      style="padding: 0px 15px 0px 15px"
    >
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </li>
  </ul>
</ng-template>

<app-chart-popup
  [chartType]="chartPopupType"
  [dataToUse]="chartPopupDataToUse"
  [(showPopup)]="chartPopupVisible"
  (closePopup)="hideChartPopup()"
  [beginningStateReferrer]="beginningStateReferrer"
  [closeFeature]="feature"
></app-chart-popup>

<ng-template #linkPopoverTemplate>
  <app-line-item-links
    [ticker]="ticker"
    [dapParameterId]="selectedLineItem"
  ></app-line-item-links>
</ng-template>
